/**
 * Notification type constants for the activity log
 */
export const NOTIFICATION_TYPES = {
  CHECKIN_REVIEWED: 'checkin_reviewed',
  PROGRAM_ASSIGNED: 'program_assigned',
  MESSAGE_RECEIVED: 'message_received',
  SKILL_FOCUSED: 'skill_focused',
  SKILL_SKIPPED: 'skill_skipped',
  CHECKIN_SUBMITTED: 'checkin_submitted',
  PRACTICE_LOGGED: 'practice_logged',
  MILESTONE_COMPLETED: 'milestone_completed',
  MODULE_ASSIGNED: 'module_assigned',
  MODULE_COMPLETED: 'module_completed',
};
